import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import AdminUsers from "./pages/AdminUsers";
import AdminChannels from "./pages/AdminChannels";
import PostReplies from "./pages/PostReplies";
import AppLayout from "./layout/AppLayout";
import { getCurrentUser } from "./api/users";

export default function App() {
  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const [username, setUsername] = useState(() => localStorage.getItem("username") || "Member");
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    if (!token) {
      setCurrentUser(null);
      return undefined;
    }

    let isActive = true;
    getCurrentUser(token)
      .then((response) => {
        if (isActive) setCurrentUser(response.data?.user || response.data?.profile || response.data);
      })
      .catch(() => {
        if (isActive) setCurrentUser(null);
      });

    return () => {
      isActive = false;
    };
  }, [token]);

  function handleLogin(authToken, accountName) {
    localStorage.setItem("token", authToken);
    localStorage.setItem("username", accountName);
    setToken(authToken);
    setUsername(accountName);
  }

  function handleLogout() {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    setToken(null);
    setUsername("Member");
    setCurrentUser(null);
  }

  return (
    <BrowserRouter>
      <Routes>

        <Route path="/" element={<Home token={token} currentUserId={currentUser?.id ?? currentUser?.user_id} isAuthenticated={Boolean(token)} displayName={username} isAdmin={currentUser?.is_admin === true} canDeleteMessages={currentUser?.is_admin === true && currentUser?.is_active === true && currentUser?.is_approved === true} onLogout={handleLogout} />} />
        <Route path="/login" element={token ? <Navigate to="/" replace /> : <Login onLogin={handleLogin} />} />
        <Route path="/register" element={token ? <Navigate to="/" replace /> : <Register onLogin={handleLogin} />} />

        <Route
          path="/messages/:channelId/:messageId"
          element={
            token ? (
              <AppLayout onLogout={handleLogout} isAdmin={currentUser?.is_admin === true}>
                <PostReplies
                  token={token}
                  currentUserId={currentUser?.id ?? currentUser?.user_id}
                  canDeleteMessages={currentUser?.is_admin === true && currentUser?.is_active === true && currentUser?.is_approved === true}
                />
              </AppLayout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/profile"
          element={
            token ? (
              <AppLayout onLogout={handleLogout}>
                <Profile user={username} onLogout={handleLogout} />
              </AppLayout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        <Route
          path="/admin/users"
          element={
            token ? (
              <AppLayout onLogout={handleLogout} isAdmin={currentUser?.is_admin === true}>
                <AdminUsers token={token} />
              </AppLayout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/admin/channels"
          element={
            token ? (
              <AppLayout onLogout={handleLogout} isAdmin={currentUser?.is_admin === true}>
                <AdminChannels token={token} />
              </AppLayout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
